import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

import LocationObject from 'entities/locationObject/model';
import { renderAddress } from 'utils/renderAddress';
import { selectUser } from 'entities/user/selectors';

interface ChapterRequest {
  id: string;
  nonprofitName: string;
  locationObject: LocationObject;
  createdAt: string;
  modifiedAt: string;
  status: string;
  metadata: {
    rejectionReason: string;
  };
}

const ChapterRequestRow = ({ chapterRequest }: { chapterRequest: ChapterRequest }) => {
  const user = useSelector(selectUser);

  if (!user) {
    return null;
  }

  const { nonprofitName, locationObject, createdAt, modifiedAt, status, metadata } = chapterRequest;

  return (
    <TableRow style={{ height: 60 }}>
      <TableCell>{nonprofitName}</TableCell>
      <TableCell>{renderAddress(locationObject)}</TableCell>
      <TableCell>{format(new Date(createdAt), 'MMM d, yyyy')}</TableCell>
      <TableCell>{format(new Date(modifiedAt), 'MMM d, yyyy')}</TableCell>
      <TableCell>{metadata?.rejectionReason}</TableCell>
      <TableCell>{status}</TableCell>
    </TableRow>
  );
};

export default ChapterRequestRow;
